import { BREAKPOINTS } from './breakpoints';
export const DEVICE_TYPES = Object.keys(BREAKPOINTS).reduce((obj, key) => {
  obj[BREAKPOINTS[key]] = key;
  return obj;
}, {});